<footer
  class="mx-auto w-11/12 pb-6"
  [ngClass]="{
    'lg:w-8/12 md:w-10/12': store.option_layout.sizeXL(),
    'lg:w-6/12 md:w-8/12': !store.option_layout.sizeXL(),
    'md:flex md:flex-col md:justify-center': store.option_layout.vertical_align(),
  }"
>
  <div class="composite-footer h-32 md:h-40 lg:h-48"></div>
  <p class="text-secondary-underline text-center">
    <a
      class="cursor-pointer"
      (click)="redirect()"
      [innerHTML]="resource.footer.text"
    ></a>
  </p>
</footer>
